import type { PriceDevelopmentDto } from "../../../autogen/bff-api";

export interface PriceChange {
  amount: number;
  percent: number;
}

export interface StagePrice {
  price: number | null;
  participated: boolean;
  changeFromPrevious: PriceChange | null;
}

export interface SupplierDevelopment {
  supplierId: string;
  supplierName: string;
  stages: StagePrice[];
  totalChange: PriceChange | null;
  inNoRound: boolean;
}

export const supplierDevelopments = (dto: PriceDevelopmentDto): SupplierDevelopment[] =>
  dto.suppliers.map((supplier) => {
    const prices = supplier.prices.map((price) => (price == null ? null : Number(price)));
    const stages = prices.map((price, index) => ({
      price,
      participated: supplier.participated[index] ?? price != null,
      changeFromPrevious: index === 0 ? null : changeBetween(latestBefore(prices, index), price),
    }));
    const lastRoundPrice = latestBefore(prices.slice(1), prices.length - 1);
    return {
      supplierId: supplier.supplierId,
      supplierName: supplier.supplierName,
      stages,
      totalChange: changeBetween(prices[0], lastRoundPrice),
      inNoRound: prices.length > 1 && !stages.slice(1).some((stage) => stage.participated),
    };
  });

const latestBefore = (prices: (number | null)[], index: number): number | null =>
  prices.slice(0, index).reverse().find((price) => price != null) ?? null;

const changeBetween = (from: number | null, to: number | null): PriceChange | null => {
  if (from == null || to == null || from === 0) return null;
  const amount = to - from;
  return { amount, percent: (amount / from) * 100 };
};
